export default "__VITE_ASSET__BLn_F2yJ__"